const firebaseConfig = {
    apiKey: "AIzaSyCVBNzk00otwI-yms3mKll87TVsd5g7DO0",
    authDomain: "letsgo-ece70.firebaseapp.com",
    projectId: "letsgo-ece70",
    storageBucket: "letsgo-ece70.appspot.com",
    messagingSenderId: "511940441492",
    appId: "1:511940441492:web:72ffcefc892a8819898b81"
  };

  export default firebaseConfig;